import axios from 'axios'
import 'promise.prototype.finally'; // https://github.com/axios/axios/issues/34#issuecomment-71079744

import AWN from "awesome-notifications"
import "awesome-notifications/dist/style.css";

let notifier = new AWN({
	maxNotifications: 6,
	position: 'bottom-right',
	labels: {
		alert: "Errore",
		success: "Tutto OK"
	}
});


export default {
	install: function (Vue, options) { // https://vuejs.org/v2/guide/plugins.html
		try {
			if (!localStorage)
				throw "localStorage is required";

			if (!options.baseURL)
				throw "apiUrl is empty";


			this.data.request = (params) => this.request(params);


			// Generic set and get to localstorage
			this.data.setObject = (name, data) => {
				localStorage[name] = JSON.stringify(data);
			};

			this.data.getObject = (name, index) => {
				try {
					if (name in this.storeVM.lsCache) {

						if (index) {
							if (this.storeVM.lsCache[name][index]) {
								return this.storeVM.lsCache[name][index];
							} else {
								throw `getObject: Unknown index ${index}`;
							}
						}

						return this.storeVM.lsCache[name];

					} else {

						if (localStorage[name]) {
							var data = JSON.parse(localStorage[name]);
							Vue.set(this.storeVM.lsCache, name, data);

							return this.data.getObject(name, index);

						} else {
							throw `getObject: Unknown object ${name}`;
						}
					}
				} catch (error) {
					return {
						id: -1,
						name: 'Unknown',
						valueOf: function () {
							return false;
						},
						toString() {
							return false;
						}
					};
				}
			};

			// i'm lazy
			this.data.setUser = (data) => this.storeVM.setObject('user', data);
			this.data.getUser = () => this.storeVM.getObject('user');

			// i'm so damn lazy
			this.data.getUserRole = () => this.storeVM.getObject('roles', this.storeVM.getObject('user').roleId);

			this.data.doLogout = () => {
				Vue.delete(this.storeVM.lsCache, 'user');
				delete localStorage.user;
				delete localStorage.token;
				delete localStorage.productsUm;
				delete localStorage.roles;
				delete localStorage.regions;
				delete localStorage.servicesTipology;
			};

			this.storeVM = new Vue({
				data: this.data
			});

			Vue.prototype.$ajax = this.storeVM;


			this.myAxios = axios.create({
				baseURL: options.baseURL,
				withCredentials: true,
				maxRedirects: 10,
				maxContentLength: 50 * 1000 * 1000, // to 50MBs, just in case

				headers: {
					'Content-Type': 'application/json',
					Authorization: {
						toString() {
							return `Bearer ${localStorage.token}`
						}
					}
				}
			});

			/* 1. add global method or property
			// Vue.ajax(..)
			Vue.ajax = function () {
				return "suka";
			}
			*/

		} catch (error) {
			throw error;
		}
	},


	storeVM: Object,


	data: {
		anyLoading: false,
		request: Function,

		// TODO: 
		isLoading: () => {
			return false;
			//this.requests[index]
		},

		getToken: () => localStorage.token,
		setToken: (token) => localStorage.token = token,

		getUser: Function,
		setUser: Function,
		doLogout: Function,

		/// localstorage cache - won't deserialize each time
		lsCache: {}, // its reactive :)
	},




	requests: Object,

	// axios object
	myAxios: Object,


	/*
		{
			address: /management/add,
			data: {},
			method: {},
			onSuccess: {},
			onFinally: {},
			onFail: {},
		}
	*/
	request: function (params) {

		if (!params.method)
			params.method = "POST";

		if (!params.silent)
			this.data.anyLoading = true;

		var axios_params = {
			url: params.address,
			method: params.method,
			data: params.data
		};

		var promise = this.myAxios({
			...axios_params,
			...params
		})
			.then(ajax => {
				// console.log(ajax);

				//if (!params.silent)
				//	notifier.success('Operazione completata')
				//				if (!params.silent)
				//					this.storeVM.$toast.open({
				//						duration: 966,
				//						message: `Operazione completata: <b>${ajax.request.responseURL.replace(ajax.config.baseURL, '')}</b>`,
				//						position: 'is-bottom',
				//						type: 'is-success'
				//					})

				if (params.onSuccess instanceof Function) params.onSuccess(ajax);
			})
			.catch((error) => {
				var errormsg = 'Unknown error';

				//let errorObject = JSON.parse(JSON.stringify(error));
				//console.log(errorObject);

				// The request was made and the server responded with a status code
				if (error.response) {

					if (error.response.data.title) {
						errormsg = error.response.data.title;

					} else if (error.response.data) {
						// that falls out of the range of 2xx
						errormsg = error.response.data ? error.response.data.error : `<i>${error.response.statusText}</i> <small>(${error.response.status})</small>`;

						var data = error.response.data;
						if (data.error) {
							errormsg = data.error;
						}
						else {
							if (data instanceof Object) {
								for (const property in data) {
									errormsg = data[property][0];
								}
							}
						}
					} else {
						errormsg = `<i>${error.response.statusText}</i> <small>(${error.response.status})</small>`;
					}
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					errormsg = `Impossibile raggiungere il server`;

				} else {
					// Something happened in setting up the request that triggered an Error
					errormsg = error.message;

				}

				notifier.alert(errormsg);
				//this.storeVM.$toast.open({
				//	duration: 4000,
				//	message: `${errormsg}</b>`,
				//	position: 'is-bottom',
				//	type: 'is-danger'
				//})

				if (params.onFail instanceof Function) params.onFail(error);
			})
			.finally(e => {

				if (!params.silent)
					this.data.anyLoading = false;

				if (params.onFinally instanceof Function) params.onFinally(e);
			});

		if (!params.silent) {
			notifier.async(promise, null, null, "Requesting:" + params.address)
		}

		// aggiungo la promessa all'elenco e poi boh
		this.requests[params.address] = promise;
		return promise;
	},
}